import React from "react"
import PropTypes from "prop-types"

import "./Button.scss"

function Button(props) {
  const onClick = (e) => {
    e.preventDefault()
    if(props.onClick) {
      props.onClick(props.data)
    }
  }
  const label = props.label || props.children

  return (
      <button 
        className={`c-button ${props.className || ''} ${props.disabled ? 'action-disabled' : 'action-' + props.kind} ${props.wide ? "wide" : ""} ${props.size || ""}`} 
        onClick={onClick}
        disabled={props.disabled}
      >
          {label}
      </button>
  )
}

Button.propTypes = {
  disabled: PropTypes.bool.isRequired,
  data: PropTypes.any,
  kind: PropTypes.oneOf(["ok", "ok-secondary", "add", "add-secondary", "confirm", "confirm-secondary", "delete", "remove", "close"]).isRequired,
  onClick: PropTypes.func
}

Button.defaultProps = {
  disabled:false,
  kind:"ok"
}

export default Button